import { Component, Input, TemplateRef } from '@angular/core';
import { BaseComponent } from '../_common/dx-base-component';

@Component({
    selector: 'dx-widget',
    templateUrl: './widget.component.html',
    styleUrls: ['./widget.component.scss'],
    standalone: false
})
export class WidgetComponent extends BaseComponent {
    @Input() MainTitle!: TemplateRef<any>;
    @Input() Content!: TemplateRef<any>;
    @Input() WidgetHeader!: TemplateRef<any>;
    @Input() Widgetfooter!: TemplateRef<any>;
    @Input() Toolbar!: TemplateRef<any>;
  
    override ngOnInit() {
        super.ngOnInit();
    }
}
